const routesList = {
  loading: {
    position: -1
  },
  landing: {
    position: 0
  },
  home: {
    position: 2,
    navName: 'Scopri Pololab',
    footerName: 'Laboratorio',
    path: '/laboratorio/'
  },
  services: {
    position: 3,
    navName: 'Scopri i Servizi',
    footerName: 'Servizi',
    path: '/servizi/'
  },
  solutions: {
    position: 4,
    navName: 'Scopri le Soluzioni',
    footerName: 'Soluzioni',
    path: '/soluzioni/'
  },
  company: {
    position: 5,
    navName: 'Scopri la Ricerca',
    footerName: 'Ricerca',
    path: '/ricerca-e-sviluppo/'
  },
  greenSpirit: {
    position: 6,
    navName: 'Scopri la Qualità',
    footerName: 'Qualità',
    path: '/sistema-di-qualita/'
  }
}

export default routesList
